import { useCallback, useEffect, useState } from 'react';

import { useApi } from '@app/hooks';

import { SalesSource } from '../types';


export const useSalesSourcesState = (outlet_id: number) => {
  const [salesSources, setSalesSources] = useState<SalesSource[]>([]);
  const [isTouched, setIsTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const api = useApi();

  useEffect(() => {
    const getSalesSources = async (outlet_id: number) => {
    setIsLoading(true);
    const { data } = await api.acb.getSalesSources(outlet_id);
    setSalesSources(data.map((item) => ({
      sales_outlet_id: item.sales_outlet_id,
      source: {
        id: item.source_id,
        name: item.source_name,
      }
    })));
    setIsLoading(false);
  };
    if (!outlet_id) {
      return;
    }
    getSalesSources(outlet_id);
  }, [outlet_id]);

  const addSalesSource = useCallback(async (payload: SalesSource) => {
    setSalesSources((salesSources) => [...salesSources, payload]);
    setIsTouched(true);
  }, []);
  
  const removeSalesSource = useCallback(async (index: number) => {
    setSalesSources((salesSources) => salesSources.filter((_, i) => i !== index));
    setIsTouched(true);
  }, []);

  const updateSalesSource = useCallback(async (index: number, payload: SalesSource) => {
    if (index === -1) {
      return;
    }
    setSalesSources((salesSources) => salesSources.map((item, i) => i === index ? payload : item));
    setIsTouched(true);
  }, []);

  return { salesSources, isLoading, isTouched, addSalesSource, removeSalesSource, updateSalesSource };
};